import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-sage/10 px-5 py-12 sm:py-20" data-id="element-91" data-mp="1o5zqy212ub4m">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-sage/40 bg-white/60 p-8 text-center sm:p-12" data-id="element-92" data-mp="222wh019dfokg">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-sage/15 text-dark-green" data-id="element-93" data-mp="1j4k8mhqaaipx">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-94" data-mp="1ee3t8s2wkn0x" />
        </span>
        <h2 className="mt-5 font-serif-display text-2xl font-bold text-slate sm:text-3xl" data-id="element-95" data-mp="1ec0wlp78vvn8">
          14-Day Zero-Risk Money-Back Guarantee
        </h2>
        <p className="mt-2 text-sm font-medium text-dark-green sm:text-base" data-id="element-96" data-mp="lodcscdst91n">
          Your Investment Is Fully Protected
        </p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-slate/75 sm:text-base" data-id="element-97" data-mp="oxf780y3m9oc">
          <p data-id="element-98" data-mp="twi591fnvfmt">
            Access the complete system, review all 6 volumes and 4 bonuses, apply it in your consultations, and see for yourself if it transforms your practice.
          </p>
          <p data-id="element-99" data-mp="12q4wce8xbupo">
            If within the first 14 days it is not everything you expected, we will refund 100% of your investment. No questions. No complicated process. No hassle.
          </p>
          <p className="font-semibold italic text-slate" data-id="element-100" data-mp="b0a68fd8s0zy">
            The risk is entirely ours. The decision is entirely yours.
          </p>
        </div>
        <div className="mt-8 w-full max-w-md" data-id="element-101" data-mp="k0ybakknqr0p">
          <CTAButton label="GET MY COMPLETE SYSTEM NOW" data-id="element-102" data-mp="k1q7nxm2wss1" />
          <p className="mt-3 text-xs text-slate/60 sm:text-sm" data-id="element-103" data-mp="1qhac6tev6mzz">14-Day Money-Back Guarantee Included</p>
        </div>
      </motion.div>
    </section>;
}